import DocumentType from "../utils/services/documentTypeServise.js";
import crudTemplate from "../templates/crudTemplate.js";

let crud = crudTemplate(DocumentType);
export default {
  namespaced: true,
  ...crud
};
